import { getHdc1Dot5MembershipId } from "../builders/getHdc1Dot5MembershipId";
import { getHdc1Dot5MembershipDetails } from "../builders/getHdc1Dot5MembershipDetails";
import {
  hdcAutoPayAlertMock,
  hdcBillPastDueMock,
  insuranceAutoPayFailed,
  insuranceBillWithRevalOffer,
} from "../builders/createInsuranceBill";
import { mockPolicies, MockPolicyId } from "../mockPolicies";
import { getMockEndorsements } from "../builders/getMockEndorsements";
import { omniCanadaSecondGearMember } from "../mockMembers";
import {
  cigAutoPayFailedBill,
  cigHdcAutoPayFailedBill,
  cigHdcPastDueBill,
  cigRevalBill,
} from "../builders/createCigBill";

import { MockPersona } from "./mockPersonas.types";

const hdcLevel = 2;
const canadaPolicies: MockPolicyId[] = ["dc101", "dc102"];
const endoNumberIds = ["97324188"];

export const alexTrebek: MockPersona = {
  key: "alexTrebek",
  name: "Alex Trebek",
  description: "🇨🇦 | Multiple policies, one with broker, two Enthusiast+ | HDC 1.5 Single-tier | All alerts | MFA",
  hasMfa: true,
  providerApiMockResponses: {
    cig: {
      billing: {
        fees: [],
        bills: [
          cigAutoPayFailedBill({ id: "1", productNumber: canadaPolicies[0] }),
          cigHdcPastDueBill("1.5", { id: "2" }),
          cigHdcAutoPayFailedBill("1.5", { id: "3" }),
          cigRevalBill({ id: "4", productNumber: canadaPolicies[1] }),
        ],
      },
      policies: {
        usa: [],
        canada: [
          mockPolicies["dc101"],
          mockPolicies["CC723641-01"],
          mockPolicies["apexCan001"],
          mockPolicies["apexCan002"],
        ],
      },
    },
    hdc: {
      fetch1Dot5MembershipId: getHdc1Dot5MembershipId("HDC01981376"),
      fetch1Dot5MembershipDetails: getHdc1Dot5MembershipDetails({
        level: hdcLevel,
      }),
    },
    esign: {
      fetchESignDocuments: [{ Id: 1, StateRegion: "QC" }],
      createESignRequest: "success",
    },
    insurance: {
      fetchEndorsement: getMockEndorsements(endoNumberIds),
      updateVehicleCoverages: {
        VehicleCoverages: [
          {
            Name: "Comprehensive",
            Type: 5,
            IsSelected: null,
            Deductibles: [
              {
                Id: 12,
                Name: "$0 Deductible",
                IsDefault: true,
                IsSelected: true,
              },
              {
                Id: 14,
                Name: "$500 Deductible",
                IsDefault: false,
                IsSelected: false,
              },
              {
                Id: 15,
                Name: "$1000 Deductible",
                IsDefault: false,
                IsSelected: false,
              },
              {
                Id: 22,
                Name: "$1500 Deductible",
                IsDefault: false,
                IsSelected: false,
              },
              {
                Id: 16,
                Name: "$2500 Deductible",
                IsDefault: false,
                IsSelected: false,
              },
              {
                Id: 17,
                Name: "$5000 Deductible",
                IsDefault: false,
                IsSelected: false,
              },
              {
                Id: 18,
                Name: "$10000 Deductible",
                IsDefault: false,
                IsSelected: false,
              },
              {
                Id: 19,
                Name: "$20000 Deductible",
                IsDefault: false,
                IsSelected: false,
              },
            ],
            Premium: null,
          },
          {
            Name: "Collision",
            Type: 4,
            IsSelected: null,
            Deductibles: [
              {
                Id: 1,
                Name: "$0 Deductible",
                IsDefault: true,
                IsSelected: false,
              },
              {
                Id: 3,
                Name: "$500 Deductible",
                IsDefault: false,
                IsSelected: false,
              },
              {
                Id: 4,
                Name: "$1000 Deductible",
                IsDefault: false,
                IsSelected: false,
              },
              {
                Id: 11,
                Name: "$1500 Deductible",
                IsDefault: false,
                IsSelected: false,
              },
              {
                Id: 5,
                Name: "$2500 Deductible",
                IsDefault: false,
                IsSelected: true,
              },
              {
                Id: 6,
                Name: "$5000 Deductible",
                IsDefault: false,
                IsSelected: false,
              },
              {
                Id: 7,
                Name: "$10000 Deductible",
                IsDefault: false,
                IsSelected: false,
              },
              {
                Id: 8,
                Name: "$20000 Deductible",
                IsDefault: false,
                IsSelected: false,
              },
            ],
            Premium: null,
          },
        ],
        AdditionalCoverages: [
          {
            Name: "Vehicle Under Construction Endorsement",
            Type: 303,
            IsSelected: false,
            Deductibles: [],
            Premium: 20,
          },
          {
            Name: "Motorsports Advantage™ Endorsement",
            Type: 395,
            IsSelected: false,
            Deductibles: [],
            Premium: 20,
          },
          {
            Name: "Limited Trailer and Paddock",
            Type: 19,
            IsSelected: null,
            Deductibles: [
              {
                Id: -1,
                Name: "Declined",
                IsDefault: false,
                IsSelected: false,
              },
              {
                Id: 0,
                Name: "$0 Deductible",
                IsDefault: true,
                IsSelected: false,
              },
              {
                Id: 500,
                Name: "$500 Deductible",
                IsDefault: false,
                IsSelected: false,
              },
              {
                Id: 1000,
                Name: "$1000 Deductible",
                IsDefault: false,
                IsSelected: false,
              },
              {
                Id: 1500,
                Name: "$1500 Deductible",
                IsDefault: false,
                IsSelected: false,
              },
              {
                Id: 2500,
                Name: "$2500 Deductible",
                IsDefault: false,
                IsSelected: false,
              },
              {
                Id: 5000,
                Name: "$5000 Deductible",
                IsDefault: false,
                IsSelected: false,
              },
              {
                Id: 10000,
                Name: "$10000 Deductible",
                IsDefault: false,
                IsSelected: false,
              },
              {
                Id: 20000,
                Name: "$20000 Deductible",
                IsDefault: false,
                IsSelected: false,
              },
            ],
            Premium: null,
          },
        ],
        Features: [
          {
            Id: 113071,
            Name: "Cherished Salvage®",
            Group: "CHSVG",
            Factor: null,
            IsSelected: false,
          },
        ],
      },
    },
    soul: {
      fetchSoul: {
        hagertyAccounts: {
          myHagertyAccount: {
            id: "1",
            loginEmail: "alex@trebek.com",
            firstName: "Alex",
            middleName: "",
            lastName: "Trebek",
            mailingAddress: {
              line1: "234 Island Highway",
              line2: "",
              city: "Bowser",
              state: "BC",
              postalCode: "V0R 1G0",
              country: "CANADA",
            },
            preferredPhone: "2509128534",
            salesforceAccounts: [
              {
                accountNumber: "123",
                id: "1",
                partnerId: null,
              },
            ],
            drivetrainAccounts: [
              {
                customerAccountLegacyKey: "000001",
                source: "CANADA",
                customerSourceSystemKey: "123",
                id: "1",
                partnerCustomerId: "123",
                partnerId: "UNKNOWN",
              },
            ],
            identityAccounts: [],
            message: undefined,
          },
        },
      },
    },
    member: {
      fetchMember: {
        member: {
          member: omniCanadaSecondGearMember,
        },
      },
    },
    billing: {
      fetchBilling: {
        bills: {
          bills: [
            insuranceAutoPayFailed({ id: "1", policyNumber: canadaPolicies[0] }),
            hdcBillPastDueMock({ id: "2" }),
            hdcAutoPayAlertMock({ id: "3" }),
            insuranceBillWithRevalOffer({ id: "4", policyNumber: canadaPolicies[1] }),
          ],
          outstandingBalance: 1,
        },
      },
    },
    payments: {
      fetchPayEndorsementUrl: { payEndorsementUrl: "mock-url" },
    },
  },
};
